export type StytchError = {
    status_code: number;
    error_type: string;
    error_message: string;
}

export function isStytchError(err: unknown): err is StytchError {
    return (
        typeof err === 'object' &&
        err !== null &&
        'error_message' in err &&
        typeof (err as any).error_message === 'string'
    );
}